import { render, staticRenderFns } from "./ChallengesUsers.vue?vue&type=template&id=90fdd52e&"
import script from "./ChallengesUsers.vue?vue&type=script&lang=js&"
export * from "./ChallengesUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports